import React, { useState } from "react";
import styles from "./whitelistingSettings.module.css";
import { useAllProduct } from "../../../../api-context/commonApiContext";
import config from "../../../../service/config";
import FullScreenLoader from "../../../../reusable/loader/FullScreenLoader";

const WhitelistingSettings = ({ selectedEscrow }) => {
  const { setRefreshWhitelistingSettings, loading, setLoading } =
    useAllProduct();
  const [isCollectWhitelisted, setIsCollectWhitelisted] = useState(
    selectedEscrow.collects_enabled || false
  );
  const [isPayoutWhitelisted, setIsPayoutWhitelisted] = useState(
    selectedEscrow.payouts_enabled || false
  );

  const handleSave = () => {
    setLoading(true);
    fetch(`${config.node_api_endpoint}/api/escrow-settings`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({
        client_id: selectedEscrow.client_id,
        main_escrow_id: selectedEscrow.main_escrow_id,
        collects_enabled: isCollectWhitelisted,
        payouts_enabled: isPayoutWhitelisted,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setRefreshWhitelistingSettings(true);
        } else {
          alert(result.message || "Failed to save settings");
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      })
      .finally(() => {
        setLoading(false); // End loader
      });
  };

  console.log("selectedEscrow", selectedEscrow);

  return (
    <>
      <FullScreenLoader spinning={loading} />
      <div className="pt-3">
        <div className="form-check form-switch mb-3 d-flex align-items-center gap-5">
          <label className="form-check-label" htmlFor="whitelistCollects">
            Whitelisting for collects
          </label>
          <input
            className={`form-check-input ${styles.customswitch}`}
            type="checkbox"
            role="switch"
            id="whitelistCollects"
            style={{ width: "3em" }}
            checked={isCollectWhitelisted}
            onChange={(e) => setIsCollectWhitelisted(e.target.checked)}
          />
        </div>

        <div className="form-check form-switch mb-4 d-flex align-items-center gap-5">
          <label className="form-check-label" htmlFor="whitelistPayouts">
            Whitelisting for payouts
          </label>
          <input
            className={`form-check-input ${styles.customswitch}`}
            type="checkbox"
            role="switch"
            style={{ width: "3em" }}
            id="whitelistPayouts"
            checked={isPayoutWhitelisted}
            onChange={(e) => setIsPayoutWhitelisted(e.target.checked)}
          />
        </div>

        <div className="mx-4">
          <button
            className="btn px-5"
            style={{ color: "#FFFFFF", backgroundColor: "#2348AB" }}
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};

export default WhitelistingSettings;
